import { __assign } from "tslib";
import React from 'react';
import StatusThumbHtmlView from './StatusHtml';
import StatusThumbReactView from './Status';
var StatusThumbView = function (props) {
    if (props.isHtml) {
        return React.createElement(StatusThumbHtmlView, __assign({}, props));
    }
    return React.createElement(StatusThumbReactView, __assign({}, props));
};
StatusThumbView.displayName = 'StatusThumbView';
export default StatusThumbView;
//# sourceMappingURL=index.js.map